import { render, staticRenderFns } from "./BlockType8.vue?vue&type=template&id=cc1a6bd0&scoped=true&"
import script from "./BlockType8.vue?vue&type=script&lang=ts&"
export * from "./BlockType8.vue?vue&type=script&lang=ts&"
import style0 from "./BlockType8.vue?vue&type=style&index=0&id=cc1a6bd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc1a6bd0",
  null
  
)

export default component.exports